import { useQuery } from "@tanstack/react-query";
import api from "@/lib/axios-interceptor";

export function usePhenoQuery(type: string): {
  data?: types.Pheno[];
  error: Error | null;
  isLoading: boolean;
} {
  const isEnabled = !!type;

  const { data, error, isLoading } = useQuery<types.Pheno[]>({
    queryKey: ["pheno", type],
    queryFn: async () => {
      const res = await api.get<types.Pheno[]>(`/v1/pheno/${type}`);
      return res.data;
    },
    enabled: isEnabled,
  });

  return {
    data,
    error: error as Error | null,
    isLoading,
  };
}


export function useCurrentPhenoQuery(type: string): {
  data?: types.CurrentPheno;
  error: Error | null;
  isLoading: boolean;
} {
  const isEnabled = !!type || ["ulaanbaatar", "erdenet", "darkhan"].includes(type);

  const { data, error, isLoading } = useQuery<types.CurrentPheno>({
    queryKey: ["pheno", "now", type],
    queryFn: async () => {
      const res = await api.get<types.CurrentPheno>(`/v1/pheno/now/${type}`);
      return res.data;
    },
    enabled: isEnabled,
  });

  return {
    data,
    error: error as Error | null,
    isLoading,
  };
}